/**
 * Pricing & Services page translations
 */
export const pricing = {
  en: {
    title: "Pricing & Services",
    subtitle: "Manage services, pricing tiers, and bundles",
    priceCalculator: "Price Calculator",
    pricesMobile: "Prices",
    serviceCatalog: "Catalog",
    bundles: "Bundles",
    // BundlesTab
    bundlesTitle: "Service Bundles",
    bundlesSubtitle: "Manage bundled service packages with special pricing",
    addBundle: "Add Bundle",
    totalBundles: "Total Bundles",
    avgSavings: "Avg. Savings",
    showInactiveBundles: "Show inactive bundles",
    bundle: "Bundle",
    includedServices: "Included Services",
    savings: "Savings",
    percentOff: "% off",
    editBundle: "Edit Bundle",
    deleteBundle: "Delete Bundle",
    loadingBundles: "Loading bundles...",
    noBundlesFound: 'No bundles found. Click "Add Bundle" to create one.',
    addBundleTitle: "Add Bundle",
    addBundleDesc: "Create a new service bundle with special pricing",
    bundleCode: "Code",
    bundlePrice: "Price",
    bundleSavingsPercent: "Savings %",
    nameEnglish: "Name (English)",
    nameSpanish: "Name (Spanish)",
    descriptionEnglish: "Description (English)",
    descriptionSpanish: "Description (Spanish)",
    idealForEnglish: "Ideal For (English)",
    idealForSpanish: "Ideal For (Spanish)",
    bundleActiveVisible: "Active (visible on website)",
    createBundle: "Create Bundle",
    editBundleTitle: "Edit Bundle",
    editBundleDesc: "Update bundle details and pricing",
    saveChanges: "Save Changes",
    deleteBundleConfirm: "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
    // PriceCalculatorTab
    allTiers: "All Tiers",
    healthy: "Healthy",
    warning: "Warning",
    atRisk: "At Risk",
    avgMargin: "Avg. Margin",
    pricingParameters: "Pricing Parameters",
    pricingParametersDesc: "Current rates used for cost calculations",
    laborRate: "Labor Rate ($/hr)",
    techOverhead: "Tech Overhead ($/hr)",
    hoursPerDay: "Hours/Day",
    feedbackWait: "Feedback Wait (days)",
    laborRateLabel: "Labor Rate:",
    techOverheadLabel: "Tech Overhead:",
    hoursPerDayLabel: "Hours/Day:",
    feedbackWaitLabel: "Feedback Wait:",
    daysLabel: "days",
    serviceTiers: "Service Tiers",
    serviceTiersDesc: "Click a service to expand and see tier details",
    selected: "selected",
    tierSingular: "tier",
    tierPlural: "tiers",
    avgMarginLabel: "Avg margin:",
    totalCostBase: "Total cost base",
    execHrs: "Exec Hrs",
    feedback: "Feedback",
    totalHrs: "Total Hrs",
    days: "Days",
    cost: "Cost",
    margin: "Margin",
    work: "work",
    wait: "wait",
    labor: "Labor:",
    tech: "Tech:",
    na: "N/A",
    failedToLoadPricing: "Failed to load pricing data. Please try again.",
    // Plans tab
    plans: "Plans",
    plansTitle: "Project Plans",
    plansSubtitle: "Manage generated shareable plan links",
    totalPlans: "Total Plans",
    totalViews: "Total Views",
    activePlans: "Active Plans",
    copyLink: "Copy Link",
    openPlan: "Open Plan",
    deletePlan: "Delete Plan",
    deletePlanConfirm: "Are you sure you want to delete this plan? This action cannot be undone.",
    noPlansFound: "No plan links generated yet. Use the Share Plan button on any tier to create one.",
    linkCopied: "Copied!",
    never: "Never",
    expired: "Expired",
    expires: "Expires",
    language: "Language",
    created: "Created",
    previewPlan: "Preview Plan",
    // Automation tracking
    automation: {
      title: "Automation Tracking",
      subtitle: "Track automation progress and time savings across all deliverables",
      totalDeliverables: "Total Deliverables",
      overallAutomation: "Overall Automation",
      timeSaved: "Time Saved",
      highPriority: "High Priority",
      awaitingAutomation: "awaiting automation",
      ofTotal: "of",
      total: "total",
      automationLevels: "Automation Levels",
      automationLevelsDesc: "Distribution of deliverables by automation level",
      implementationProgress: "Implementation Progress",
      implementationProgressDesc: "Track automation implementation status",
      automationByService: "Automation by Service",
      automationByServiceDesc: "Time savings and automation breakdown per service",
      service: "Service",
      deliverables: "Deliverables",
      manual: "Manual",
      aiAssisted: "AI Assisted",
      semiAuto: "Semi-Auto",
      fullyAuto: "Fully Auto",
      manualHours: "Manual Hours",
      savedHours: "Saved Hours",
      savingsPercent: "Savings %",
      priorityGuide: "Automation Priority Guide",
      priorityGuideDesc: "Recommended tasks to automate first based on impact",
      automateFirst: "Automate First (High Impact)",
      keepManual: "Keep Manual (Human-Only)",
      competitiveAnalysis: "Competitive analysis with AI agents",
      contentCalendar: "Content calendar generation",
      socialMediaDrafts: "Social media copy drafts",
      meetingSummaries: "Meeting summaries",
      proposalDrafts: "Proposal first drafts",
      brandStrategy: "Brand strategy development",
      creativeDirection: "Creative direction",
      clientPresentations: "Client presentations",
      complexUx: "Complex UX problem solving",
      contractNegotiation: "Contract negotiation",
    },
  },
  es: {
    title: "Precios y Servicios",
    subtitle: "Gestionar servicios, niveles de precios y paquetes",
    priceCalculator: "Calculadora de Precios",
    pricesMobile: "Precios",
    serviceCatalog: "Catálogo",
    bundles: "Paquetes",
    // BundlesTab
    bundlesTitle: "Paquetes de Servicios",
    bundlesSubtitle: "Gestiona paquetes de servicios con precios especiales",
    addBundle: "Agregar Paquete",
    totalBundles: "Total Paquetes",
    avgSavings: "Ahorro Prom.",
    showInactiveBundles: "Mostrar paquetes inactivos",
    bundle: "Paquete",
    includedServices: "Servicios Incluidos",
    savings: "Ahorro",
    percentOff: "% desc.",
    editBundle: "Editar Paquete",
    deleteBundle: "Eliminar Paquete",
    loadingBundles: "Cargando paquetes...",
    noBundlesFound: 'No se encontraron paquetes. Haz clic en "Agregar Paquete" para crear uno.',
    addBundleTitle: "Agregar Paquete",
    addBundleDesc: "Crea un nuevo paquete de servicios con precios especiales",
    bundleCode: "Código",
    bundlePrice: "Precio",
    bundleSavingsPercent: "% Ahorro",
    nameEnglish: "Nombre (Inglés)",
    nameSpanish: "Nombre (Español)",
    descriptionEnglish: "Descripción (Inglés)",
    descriptionSpanish: "Descripción (Español)",
    idealForEnglish: "Ideal Para (Inglés)",
    idealForSpanish: "Ideal Para (Español)",
    bundleActiveVisible: "Activo (visible en el sitio web)",
    createBundle: "Crear Paquete",
    editBundleTitle: "Editar Paquete",
    editBundleDesc: "Actualizar detalles y precios del paquete",
    saveChanges: "Guardar Cambios",
    deleteBundleConfirm: "¿Estás seguro de que deseas eliminar \"{name}\"? Esta acción no se puede deshacer.",
    // PriceCalculatorTab
    allTiers: "Todos los Niveles",
    healthy: "Saludable",
    warning: "Advertencia",
    atRisk: "En Riesgo",
    avgMargin: "Margen Prom.",
    pricingParameters: "Parámetros de Precios",
    pricingParametersDesc: "Tarifas actuales usadas para cálculos de costos",
    laborRate: "Tarifa Laboral ($/hr)",
    techOverhead: "Costo Técnico ($/hr)",
    hoursPerDay: "Horas/Día",
    feedbackWait: "Espera de Retroalimentación (días)",
    laborRateLabel: "Tarifa Laboral:",
    techOverheadLabel: "Costo Técnico:",
    hoursPerDayLabel: "Horas/Día:",
    feedbackWaitLabel: "Espera Retroalimentación:",
    daysLabel: "días",
    serviceTiers: "Niveles de Servicio",
    serviceTiersDesc: "Haz clic en un servicio para expandir y ver detalles del nivel",
    selected: "seleccionado",
    tierSingular: "nivel",
    tierPlural: "niveles",
    avgMarginLabel: "Margen prom.:",
    totalCostBase: "Base de costo total",
    execHrs: "Hrs Ejec",
    feedback: "Retroalimentación",
    totalHrs: "Hrs Totales",
    days: "Días",
    cost: "Costo",
    margin: "Margen",
    work: "trabajo",
    wait: "espera",
    labor: "Laboral:",
    tech: "Técnico:",
    na: "N/D",
    failedToLoadPricing: "Error al cargar datos de precios. Inténtalo de nuevo.",
    // Plans tab
    plans: "Planes",
    plansTitle: "Planes de Proyecto",
    plansSubtitle: "Gestiona los enlaces de planes compartibles generados",
    totalPlans: "Total Planes",
    totalViews: "Vistas Totales",
    activePlans: "Planes Activos",
    copyLink: "Copiar Enlace",
    openPlan: "Abrir Plan",
    deletePlan: "Eliminar Plan",
    deletePlanConfirm: "¿Estás seguro de que deseas eliminar este plan? Esta acción no se puede deshacer.",
    noPlansFound: "No se han generado enlaces de plan aún. Usa el botón Compartir Plan en cualquier nivel para crear uno.",
    linkCopied: "¡Copiado!",
    never: "Nunca",
    expired: "Expirado",
    expires: "Expira",
    language: "Idioma",
    created: "Creado",
    previewPlan: "Vista Previa",
    automation: {
      title: "Seguimiento de Automatización",
      subtitle: "Seguimiento del progreso de automatización y ahorro de tiempo en todos los entregables",
      totalDeliverables: "Total Entregables",
      overallAutomation: "Automatización General",
      timeSaved: "Tiempo Ahorrado",
      highPriority: "Alta Prioridad",
      awaitingAutomation: "esperando automatización",
      ofTotal: "de",
      total: "total",
      automationLevels: "Niveles de Automatización",
      automationLevelsDesc: "Distribución de entregables por nivel de automatización",
      implementationProgress: "Progreso de Implementación",
      implementationProgressDesc: "Seguimiento del estado de implementación de automatización",
      automationByService: "Automatización por Servicio",
      automationByServiceDesc: "Ahorro de tiempo y desglose de automatización por servicio",
      service: "Servicio",
      deliverables: "Entregables",
      manual: "Manual",
      aiAssisted: "Asistido por IA",
      semiAuto: "Semi-Auto",
      fullyAuto: "Auto Completa",
      manualHours: "Horas Manuales",
      savedHours: "Horas Ahorradas",
      savingsPercent: "% Ahorro",
      priorityGuide: "Guía de Prioridad de Automatización",
      priorityGuideDesc: "Tareas recomendadas para automatizar primero según el impacto",
      automateFirst: "Automatizar Primero (Alto Impacto)",
      keepManual: "Mantener Manual (Solo Humano)",
      competitiveAnalysis: "Análisis competitivo con agentes de IA",
      contentCalendar: "Generación de calendario de contenido",
      socialMediaDrafts: "Borradores de copy para redes sociales",
      meetingSummaries: "Resúmenes de reuniones",
      proposalDrafts: "Primeros borradores de propuestas",
      brandStrategy: "Desarrollo de estrategia de marca",
      creativeDirection: "Dirección creativa",
      clientPresentations: "Presentaciones a clientes",
      complexUx: "Resolución de problemas complejos de UX",
      contractNegotiation: "Negociación de contratos",
    },
  },
};
